'use client';

import ContactSection from '@@components/page/home/ContactSection';
import ImagesSection from '@@components/page/home/ImagesSection';
import PropertiesSection from '@@components/page/home/PropertiesSection';
import TitleSection from '@@components/page/home/TitleSection';
import clx from '@@components/page/home/clx';

/**
 * DEV:
 * https://tahitiresort.hu/
 * https://zajerapartmanhaz.hu/
 * https://strand-apartman-hajduszoboszlo.booked.hu/
 * https://www.ilonaapartman-hajduszoboszlo.hu/ilona-apartman-i-galeria/
 */

/**
 * Page: Home
 */
export default async function Home() {
  return (
    <main className={clx('root')}>
      {/* Title */}
      <TitleSection />

      {/* Properties */}
      <PropertiesSection />

      {/* Images */}
      <ImagesSection />

      {/* Contact */}
      <ContactSection />
    </main>
  );
}
